// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3TdPW","left":"StickyBox_left__2fyOk","right":"StickyBox_right__2cmf1"};